module.exports = __webpack_public_path__ + "img/photo-camera.90cb5ba7.svg";